export const MANUAL_PRICE_ID = 1;

export enum SettingStatus {
  DISPLAY = "DISPLAY",
  EDITION = "EDITION",
  REGISTRATION = "REGISTRATION",
  CREATION = "CREATION",
}
